$(document).ready(function(){
  
  

  
  var p_features = $('#tab-description').find('.specs').html();
  $('.product-features').append(p_features);
  $('#tab-description').find('.specs').remove();
  
//     function scrollToAnchor(aid){
//     var aTag = aid;
//     $('html,body').animate({scrollTop: aTag.offset().top},'slow');
// }



  console.log('page loaded');
  setTimeout(function(){
    
    var levelArray = $('.tp-tabs-inner-wrapper').children();
//   var levelArray = $('.tp-tabs-inner-wrapper').map( function() {
// //     return $(this).attr('data-liindex');
//   return $(this);
// }).get();
  var div_index = $('.tp-tab').map( function() {
     return $(this).attr('data-liindex');
}).get();
  console.log(div_index);
  for(var i=0; i<=levelArray.length; i++)
  {	
    var value=parseInt(div_index[i]);
    value = value + 1;
    var label = $('<label class="tp_tab_label" id="ID_item" style="visibility:hidden;">0'+ value +'</label>');
    label.insertAfter(levelArray[i]);
  }
    	
    if($('.tp-tab').hasClass('selected')){
    	console.log('has class');
      $('.selected').next().css('visibility','visible');
		var tab_content= $('.selected>div');
		tab_content.next().addClass('Selected_active');
    }
    
  $('.tp-tab').click(function(){
    if($(this).hasClass('selected')){
      $('.tp_tab_label').css('visibility','hidden');
    $('.selected').next().css('visibility','visible');
     $('.tp-tab-image').removeClass('Selected_active');
      $('.selected>div').next().addClass('Selected_active');
    }
    else
      $('.tp_tab_label').css('visibility','hidden');

    
    });
  
  }, 5000);

$(document).find("#more_specs").click(function() {
//    scrollToAnchor($('#specs'));
  var body = $("html, body");
  body.stop().animate({scrollTop: $('#specs').offset().top}, 2000, 'swing', function() { 

});
});
//   setTimeout(function(){
//     if($('.spr-summary-caption').text() == 'No reviews yet')
// {
// 	$('div#preface-footer-preface-footer').css({"-webkit-clip-path": "polygon(50% 40%, 100% 0, 100% 100%, 0 100%, 0 0)", "clip-path": "polygon(50% 40%, 100% 0, 100% 100%, 0 100%, 0 0)"});
// }
// else{
// 	$('div#preface-footer-preface-footer').css({"-webkit-clip-path": "polygon(50% 18%, 100% 0, 100% 100%, 0 100%, 0 0)", "clip-path": "polygon(50% 18%, 100% 0, 100% 100%, 0 100%, 0 0)"});
// }}, 5000);
  
});







$(document).on('load', function(){

// var levelArray = $('.tp-tab').map( function() {
// //     return $(this).attr('data-liindex');
//   return $(this);
// }).get();
//   var div_index = $('.tp-tab').map( function() {
//      return $(this).attr('data-liindex');
// }).get();
//   console.log(div_index);
//   for(var i=0; i<=levelArray.length; i++)
//   {	
//     var value=parseInt(div_index[i]);
//     value = value + 1;
//     var label = $('<label id="ID_item">'+ value +'</label>');
//     label.insertBefore(levelArray[i]);
//   }
  
});
